import React, { Component } from "react";
import { Field, Form, Formik } from "formik";
import { Button, ControlLabel, Modal } from "react-bootstrap";
import Alert from "react-s-alert";
import * as Yup from "yup";
import FormikFormControl from "../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from "../utils/DealsService";

class CancelModal extends Component {
  render() {
    const { deal, showModal, onConfirmModal, onCloseModal } = this.props;

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Mark Deal Cancelled</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              cancel_reason: "",
              cancel_comments: ""
            }}
            validationSchema={Yup.object().shape({
              cancel_reason: Yup.string().required("Reason is required"),
              cancel_comments: Yup.string().required("Comments are required").min(15, "minimum 15 characters").max(2000, "maximum 2000 characters")
            })}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              DealsService.takeAction("cancelled", deal.id, values).then(data => {
                Alert.success("Updated");
                onConfirmModal(data);
                setSubmitting(false);
              });
            }}
          >
            {({ errors, touched, isValid, isSubmitting }) => (
              <Form>
                <FormikFormControl
                  fieldName="cancel_reason"
                  errors={errors}
                  touched={touched}
                >
                  <ControlLabel>Reason for cancelling</ControlLabel>
                  <Field
                    className="form-control input-sm"
                    name="cancel_reason"
                    component="select"
                  >
                    <option value="">-- select --</option>
                    <option value="attendee_cancelled">Attendee Cancelled</option>
                    <option value="m1_cancelled">M1 Cancelled</option>
                    <option value="other">Other</option>
                  </Field>
                </FormikFormControl>

                <FormikTextAreaControl
                  fieldLabel="Comments / Explanation"
                  fieldName="cancel_comments"
                  errors={errors}
                  touched={touched}
                />

                <div>
                  <Button onClick={onCloseModal} bsSize="small">
                    Never mind
                  </Button>
                  <Button
                    className="pull-right"
                    disabled={!isValid || isSubmitting}
                    type="submit"
                    bsStyle="danger"
                    bsSize="small"
                  >
                    Go ahead and Mark Cancelled
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CancelModal;
